'use strict';

export default {
  formConfirmPage: {
    successMessage: 'Your form "{formName}" has successfully been sent',
  },
};
